import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import useAuthentication from "../useAuthentication";
import { dbDelete } from "../../../util/db-util";
import useFirebase from "../../../util/useFirebase";

const useSignin = () => {
  const navigate = useNavigate();

  const {
    getAuth,
    GoogleAuthProvider,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signInWithRedirect,
    signInWithPopup
  } = useFirebase();

  const [queryParams] = useSearchParams();

  const {t} = useAuthentication();

  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [logingIn, setLogingIn] = useState(false);

  const passwordResetted = queryParams.has("reset") && queryParams.get("reset") === "1";

  const updateEmail = useCallback(e => setEmail(e.target.value), []);
  const updatePassword = useCallback(e => setPassword(e.target.value), []);

  const handleLogin = useCallback(e => {
    e.preventDefault();

    setLogingIn(true);

    signInWithEmailAndPassword(getAuth(), email, password).catch(e => {
      setLogingIn(false);

      if (e.code === "auth/user-not-found" || e.code === "auth/wrong-password") {
        setError(t("error_email_password_invalid"));
      } else {
        setError(t("error_while_signin"));

        console.error(e);
      }
    });
  }, [t, email, password, getAuth, signInWithEmailAndPassword]);

  const signInGoogle = useCallback(() => {
    setLogingIn(true);

    const signInFunc = process.env.REACT_APP_FIREBASE_SIGN_IN_WITH_POPUP ? signInWithPopup : signInWithRedirect;

    signInFunc(getAuth(), new GoogleAuthProvider()).catch(e => {
      console.error(e);
      setLogingIn(false);
    });
  }, [getAuth, GoogleAuthProvider, signInWithRedirect, signInWithPopup]);

  useEffect(() => {
    const unsub = onAuthStateChanged(getAuth(), user => {
      if (user) {
        return navigate("/");
      } else {
        dbDelete();

        const splash = document.getElementById("splash");

        if (splash) {
          setTimeout(() => splash.remove(), 1000);
        }
      }
    });

    return () => unsub();
  }, [navigate, getAuth, onAuthStateChanged]);

  return {
    t,
    logingIn,
    handleLogin,
    signInGoogle,
    error,
    passwordResetted,
    email,
    password,
    updateEmail,
    updatePassword
  };
};

export default useSignin;
